/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ClientData } from '../models/client-data';
import { clientManagementCreateClientPost } from '../fn/client-management/client-management-create-client-post';
import { ClientManagementCreateClientPost$Params } from '../fn/client-management/client-management-create-client-post';
import { clientManagementCreateClientPost$Plain } from '../fn/client-management/client-management-create-client-post-plain';
import { ClientManagementCreateClientPost$Plain$Params } from '../fn/client-management/client-management-create-client-post-plain';
import { clientManagementEditClientPost } from '../fn/client-management/client-management-edit-client-post';
import { ClientManagementEditClientPost$Params } from '../fn/client-management/client-management-edit-client-post';
import { clientManagementEditClientPost$Plain } from '../fn/client-management/client-management-edit-client-post-plain';
import { ClientManagementEditClientPost$Plain$Params } from '../fn/client-management/client-management-edit-client-post-plain';
import { clientManagementEditClientSetupEditClientSetupPost } from '../fn/client-management/client-management-edit-client-setup-edit-client-setup-post';
import { ClientManagementEditClientSetupEditClientSetupPost$Params } from '../fn/client-management/client-management-edit-client-setup-edit-client-setup-post';
import { clientManagementGetAllClientDynamoDbGet } from '../fn/client-management/client-management-get-all-client-dynamo-db-get';
import { ClientManagementGetAllClientDynamoDbGet$Params } from '../fn/client-management/client-management-get-all-client-dynamo-db-get';
import { clientManagementGetAllClientDynamoDbGet$Plain } from '../fn/client-management/client-management-get-all-client-dynamo-db-get-plain';
import { ClientManagementGetAllClientDynamoDbGet$Plain$Params } from '../fn/client-management/client-management-get-all-client-dynamo-db-get-plain';
import { clientManagementGetAllClientsPost } from '../fn/client-management/client-management-get-all-clients-post';
import { ClientManagementGetAllClientsPost$Params } from '../fn/client-management/client-management-get-all-clients-post';
import { clientManagementGetAllClientsPost$Plain } from '../fn/client-management/client-management-get-all-clients-post-plain';
import { ClientManagementGetAllClientsPost$Plain$Params } from '../fn/client-management/client-management-get-all-clients-post-plain';
import { clientManagementGetCaseFieldsGet } from '../fn/client-management/client-management-get-case-fields-get';
import { ClientManagementGetCaseFieldsGet$Params } from '../fn/client-management/client-management-get-case-fields-get';
import { clientManagementGetCaseFieldsGet$Plain } from '../fn/client-management/client-management-get-case-fields-get-plain';
import { ClientManagementGetCaseFieldsGet$Plain$Params } from '../fn/client-management/client-management-get-case-fields-get-plain';
import { clientManagementGetClientByIdPost } from '../fn/client-management/client-management-get-client-by-id-post';
import { ClientManagementGetClientByIdPost$Params } from '../fn/client-management/client-management-get-client-by-id-post';
import { clientManagementGetClientByIdPost$Plain } from '../fn/client-management/client-management-get-client-by-id-post-plain';
import { ClientManagementGetClientByIdPost$Plain$Params } from '../fn/client-management/client-management-get-client-by-id-post-plain';
import { clientManagementGetMappingGetMappingClientIdGet } from '../fn/client-management/client-management-get-mapping-get-mapping-client-id-get';
import { ClientManagementGetMappingGetMappingClientIdGet$Params } from '../fn/client-management/client-management-get-mapping-get-mapping-client-id-get';
import { clientManagementGetMappingGetMappingClientIdGet$Plain } from '../fn/client-management/client-management-get-mapping-get-mapping-client-id-get-plain';
import { ClientManagementGetMappingGetMappingClientIdGet$Plain$Params } from '../fn/client-management/client-management-get-mapping-get-mapping-client-id-get-plain';
import { clientManagementGetOtDocsGet } from '../fn/client-management/client-management-get-ot-docs-get';
import { ClientManagementGetOtDocsGet$Params } from '../fn/client-management/client-management-get-ot-docs-get';
import { clientManagementGetOtDocsGet$Plain } from '../fn/client-management/client-management-get-ot-docs-get-plain';
import { ClientManagementGetOtDocsGet$Plain$Params } from '../fn/client-management/client-management-get-ot-docs-get-plain';
import { clientManagementGetOtFieldsGet } from '../fn/client-management/client-management-get-ot-fields-get';
import { ClientManagementGetOtFieldsGet$Params } from '../fn/client-management/client-management-get-ot-fields-get';
import { clientManagementGetOtFieldsGet$Plain } from '../fn/client-management/client-management-get-ot-fields-get-plain';
import { ClientManagementGetOtFieldsGet$Plain$Params } from '../fn/client-management/client-management-get-ot-fields-get-plain';
import { clientManagementSaveClientSetupSaveClientSetupPost } from '../fn/client-management/client-management-save-client-setup-save-client-setup-post';
import { ClientManagementSaveClientSetupSaveClientSetupPost$Params } from '../fn/client-management/client-management-save-client-setup-save-client-setup-post';
import { clientManagementSaveMappingSaveMappingPost } from '../fn/client-management/client-management-save-mapping-save-mapping-post';
import { ClientManagementSaveMappingSaveMappingPost$Params } from '../fn/client-management/client-management-save-mapping-save-mapping-post';
import { ClientMapping } from '../models/client-mapping';
import { GeneralResponse } from '../models/general-response';
import { OutputGetAllClientDto } from '../models/output-get-all-client-dto';

@Injectable({ providedIn: 'root' })
export class ClientManagementService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `clientManagementGetAllClientsPost()` */
  static readonly ClientManagementGetAllClientsPostPath = '/ClientManagement/GetAllClients';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientManagementGetAllClientsPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientManagementGetAllClientsPost$Plain$Response(params?: ClientManagementGetAllClientsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OutputGetAllClientDto>>> {
    return clientManagementGetAllClientsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientManagementGetAllClientsPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientManagementGetAllClientsPost$Plain(params?: ClientManagementGetAllClientsPost$Plain$Params, context?: HttpContext): Observable<Array<OutputGetAllClientDto>> {
    return this.clientManagementGetAllClientsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<OutputGetAllClientDto>>): Array<OutputGetAllClientDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientManagementGetAllClientsPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientManagementGetAllClientsPost$Response(params?: ClientManagementGetAllClientsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OutputGetAllClientDto>>> {
    return clientManagementGetAllClientsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientManagementGetAllClientsPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientManagementGetAllClientsPost(params?: ClientManagementGetAllClientsPost$Params, context?: HttpContext): Observable<Array<OutputGetAllClientDto>> {
    return this.clientManagementGetAllClientsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<OutputGetAllClientDto>>): Array<OutputGetAllClientDto> => r.body)
    );
  }

  /** Path part for operation `clientManagementGetClientByIdPost()` */
  static readonly ClientManagementGetClientByIdPostPath = '/ClientManagement/GetClientById';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientManagementGetClientByIdPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientManagementGetClientByIdPost$Plain$Response(params?: ClientManagementGetClientByIdPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<OutputGetAllClientDto>> {
    return clientManagementGetClientByIdPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientManagementGetClientByIdPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientManagementGetClientByIdPost$Plain(params?: ClientManagementGetClientByIdPost$Plain$Params, context?: HttpContext): Observable<OutputGetAllClientDto> {
    return this.clientManagementGetClientByIdPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<OutputGetAllClientDto>): OutputGetAllClientDto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientManagementGetClientByIdPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientManagementGetClientByIdPost$Response(params?: ClientManagementGetClientByIdPost$Params, context?: HttpContext): Observable<StrictHttpResponse<OutputGetAllClientDto>> {
    return clientManagementGetClientByIdPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientManagementGetClientByIdPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientManagementGetClientByIdPost(params?: ClientManagementGetClientByIdPost$Params, context?: HttpContext): Observable<OutputGetAllClientDto> {
    return this.clientManagementGetClientByIdPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<OutputGetAllClientDto>): OutputGetAllClientDto => r.body)
    );
  }

  /** Path part for operation `clientManagementCreateClientPost()` */
  static readonly ClientManagementCreateClientPostPath = '/ClientManagement/CreateClient';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientManagementCreateClientPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientManagementCreateClientPost$Plain$Response(params?: ClientManagementCreateClientPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneralResponse>> {
    return clientManagementCreateClientPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientManagementCreateClientPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientManagementCreateClientPost$Plain(params?: ClientManagementCreateClientPost$Plain$Params, context?: HttpContext): Observable<GeneralResponse> {
    return this.clientManagementCreateClientPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GeneralResponse>): GeneralResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientManagementCreateClientPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientManagementCreateClientPost$Response(params?: ClientManagementCreateClientPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneralResponse>> {
    return clientManagementCreateClientPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientManagementCreateClientPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientManagementCreateClientPost(params?: ClientManagementCreateClientPost$Params, context?: HttpContext): Observable<GeneralResponse> {
    return this.clientManagementCreateClientPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GeneralResponse>): GeneralResponse => r.body)
    );
  }

  /** Path part for operation `clientManagementEditClientPost()` */
  static readonly ClientManagementEditClientPostPath = '/ClientManagement/EditClient';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientManagementEditClientPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientManagementEditClientPost$Plain$Response(params?: ClientManagementEditClientPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneralResponse>> {
    return clientManagementEditClientPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientManagementEditClientPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientManagementEditClientPost$Plain(params?: ClientManagementEditClientPost$Plain$Params, context?: HttpContext): Observable<GeneralResponse> {
    return this.clientManagementEditClientPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GeneralResponse>): GeneralResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientManagementEditClientPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientManagementEditClientPost$Response(params?: ClientManagementEditClientPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneralResponse>> {
    return clientManagementEditClientPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientManagementEditClientPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientManagementEditClientPost(params?: ClientManagementEditClientPost$Params, context?: HttpContext): Observable<GeneralResponse> {
    return this.clientManagementEditClientPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GeneralResponse>): GeneralResponse => r.body)
    );
  }

  /** Path part for operation `clientManagementGetOtFieldsGet()` */
  static readonly ClientManagementGetOtFieldsGetPath = '/ClientManagement/GetOtFields';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientManagementGetOtFieldsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientManagementGetOtFieldsGet$Plain$Response(params?: ClientManagementGetOtFieldsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return clientManagementGetOtFieldsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientManagementGetOtFieldsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientManagementGetOtFieldsGet$Plain(params?: ClientManagementGetOtFieldsGet$Plain$Params, context?: HttpContext): Observable<string> {
    return this.clientManagementGetOtFieldsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientManagementGetOtFieldsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientManagementGetOtFieldsGet$Response(params?: ClientManagementGetOtFieldsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return clientManagementGetOtFieldsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientManagementGetOtFieldsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientManagementGetOtFieldsGet(params?: ClientManagementGetOtFieldsGet$Params, context?: HttpContext): Observable<string> {
    return this.clientManagementGetOtFieldsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `clientManagementGetOtDocsGet()` */
  static readonly ClientManagementGetOtDocsGetPath = '/ClientManagement/GetOtDocs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientManagementGetOtDocsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientManagementGetOtDocsGet$Plain$Response(params?: ClientManagementGetOtDocsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return clientManagementGetOtDocsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientManagementGetOtDocsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientManagementGetOtDocsGet$Plain(params?: ClientManagementGetOtDocsGet$Plain$Params, context?: HttpContext): Observable<string> {
    return this.clientManagementGetOtDocsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientManagementGetOtDocsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientManagementGetOtDocsGet$Response(params?: ClientManagementGetOtDocsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return clientManagementGetOtDocsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientManagementGetOtDocsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientManagementGetOtDocsGet(params?: ClientManagementGetOtDocsGet$Params, context?: HttpContext): Observable<string> {
    return this.clientManagementGetOtDocsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `clientManagementGetCaseFieldsGet()` */
  static readonly ClientManagementGetCaseFieldsGetPath = '/ClientManagement/GetCaseFields';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientManagementGetCaseFieldsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientManagementGetCaseFieldsGet$Plain$Response(params?: ClientManagementGetCaseFieldsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return clientManagementGetCaseFieldsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientManagementGetCaseFieldsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientManagementGetCaseFieldsGet$Plain(params?: ClientManagementGetCaseFieldsGet$Plain$Params, context?: HttpContext): Observable<Array<string>> {
    return this.clientManagementGetCaseFieldsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientManagementGetCaseFieldsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientManagementGetCaseFieldsGet$Response(params?: ClientManagementGetCaseFieldsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return clientManagementGetCaseFieldsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientManagementGetCaseFieldsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientManagementGetCaseFieldsGet(params?: ClientManagementGetCaseFieldsGet$Params, context?: HttpContext): Observable<Array<string>> {
    return this.clientManagementGetCaseFieldsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `clientManagementGetAllClientDynamoDbGet()` */
  static readonly ClientManagementGetAllClientDynamoDbGetPath = '/ClientManagement/GetAllClientDynamoDB';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientManagementGetAllClientDynamoDbGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientManagementGetAllClientDynamoDbGet$Plain$Response(params?: ClientManagementGetAllClientDynamoDbGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientData>>> {
    return clientManagementGetAllClientDynamoDbGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientManagementGetAllClientDynamoDbGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientManagementGetAllClientDynamoDbGet$Plain(params?: ClientManagementGetAllClientDynamoDbGet$Plain$Params, context?: HttpContext): Observable<Array<ClientData>> {
    return this.clientManagementGetAllClientDynamoDbGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientData>>): Array<ClientData> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientManagementGetAllClientDynamoDbGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientManagementGetAllClientDynamoDbGet$Response(params?: ClientManagementGetAllClientDynamoDbGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientData>>> {
    return clientManagementGetAllClientDynamoDbGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientManagementGetAllClientDynamoDbGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientManagementGetAllClientDynamoDbGet(params?: ClientManagementGetAllClientDynamoDbGet$Params, context?: HttpContext): Observable<Array<ClientData>> {
    return this.clientManagementGetAllClientDynamoDbGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientData>>): Array<ClientData> => r.body)
    );
  }

  /** Path part for operation `clientManagementSaveClientSetupSaveClientSetupPost()` */
  static readonly ClientManagementSaveClientSetupSaveClientSetupPostPath = '/ClientManagement/SaveClientSetup/SaveClientSetup';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientManagementSaveClientSetupSaveClientSetupPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientManagementSaveClientSetupSaveClientSetupPost$Response(params?: ClientManagementSaveClientSetupSaveClientSetupPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return clientManagementSaveClientSetupSaveClientSetupPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientManagementSaveClientSetupSaveClientSetupPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientManagementSaveClientSetupSaveClientSetupPost(params?: ClientManagementSaveClientSetupSaveClientSetupPost$Params, context?: HttpContext): Observable<void> {
    return this.clientManagementSaveClientSetupSaveClientSetupPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `clientManagementEditClientSetupEditClientSetupPost()` */
  static readonly ClientManagementEditClientSetupEditClientSetupPostPath = '/ClientManagement/EditClientSetup/EditClientSetup';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientManagementEditClientSetupEditClientSetupPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientManagementEditClientSetupEditClientSetupPost$Response(params?: ClientManagementEditClientSetupEditClientSetupPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return clientManagementEditClientSetupEditClientSetupPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientManagementEditClientSetupEditClientSetupPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientManagementEditClientSetupEditClientSetupPost(params?: ClientManagementEditClientSetupEditClientSetupPost$Params, context?: HttpContext): Observable<void> {
    return this.clientManagementEditClientSetupEditClientSetupPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `clientManagementSaveMappingSaveMappingPost()` */
  static readonly ClientManagementSaveMappingSaveMappingPostPath = '/ClientManagement/SaveMapping/SaveMapping';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientManagementSaveMappingSaveMappingPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientManagementSaveMappingSaveMappingPost$Response(params?: ClientManagementSaveMappingSaveMappingPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return clientManagementSaveMappingSaveMappingPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientManagementSaveMappingSaveMappingPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientManagementSaveMappingSaveMappingPost(params?: ClientManagementSaveMappingSaveMappingPost$Params, context?: HttpContext): Observable<void> {
    return this.clientManagementSaveMappingSaveMappingPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `clientManagementGetMappingGetMappingClientIdGet()` */
  static readonly ClientManagementGetMappingGetMappingClientIdGetPath = '/ClientManagement/GetMapping/GetMapping/{clientId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientManagementGetMappingGetMappingClientIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientManagementGetMappingGetMappingClientIdGet$Plain$Response(params: ClientManagementGetMappingGetMappingClientIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientMapping>> {
    return clientManagementGetMappingGetMappingClientIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientManagementGetMappingGetMappingClientIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientManagementGetMappingGetMappingClientIdGet$Plain(params: ClientManagementGetMappingGetMappingClientIdGet$Plain$Params, context?: HttpContext): Observable<ClientMapping> {
    return this.clientManagementGetMappingGetMappingClientIdGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientMapping>): ClientMapping => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientManagementGetMappingGetMappingClientIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientManagementGetMappingGetMappingClientIdGet$Response(params: ClientManagementGetMappingGetMappingClientIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientMapping>> {
    return clientManagementGetMappingGetMappingClientIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientManagementGetMappingGetMappingClientIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientManagementGetMappingGetMappingClientIdGet(params: ClientManagementGetMappingGetMappingClientIdGet$Params, context?: HttpContext): Observable<ClientMapping> {
    return this.clientManagementGetMappingGetMappingClientIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientMapping>): ClientMapping => r.body)
    );
  }

}
